// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import CheckCircleOutlined from '/vercel/path0/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/CheckCircleOutlined';
import UploadOutlined from '/vercel/path0/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/UploadOutlined';
import UserOutlined from '/vercel/path0/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/UserOutlined';
import TableOutlined from '/vercel/path0/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/TableOutlined';
export default { CheckCircleOutlined, UploadOutlined, UserOutlined, TableOutlined };
